import { LAYER_TYPE, getLayerType } from "./layerGeometry";

const MASK_MIME_TYPE = "image/png";

const canvasToBlob = (canvas) =>
  new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error("Could not export object-eraser mask"));
        return;
      }
      resolve(blob);
    }, MASK_MIME_TYPE);
  });

export const exportBinaryMaskFromCanvas = async (sourceCanvas) => {
  if (!sourceCanvas?.width || !sourceCanvas?.height) {
    return null;
  }

  const width = sourceCanvas.width;
  const height = sourceCanvas.height;
  const sourceContext = sourceCanvas.getContext("2d");
  const output = document.createElement("canvas");
  output.width = width;
  output.height = height;
  const outputContext = output.getContext("2d");
  if (!sourceContext || !outputContext) return null;

  const source = sourceContext.getImageData(0, 0, width, height);
  const destination = outputContext.createImageData(width, height);
  for (let index = 0; index < source.data.length; index += 4) {
    const painted = source.data[index + 3] > 8;
    const value = painted ? 255 : 0;
    destination.data[index] = value;
    destination.data[index + 1] = value;
    destination.data[index + 2] = value;
    destination.data[index + 3] = 255;
  }
  outputContext.putImageData(destination, 0, 0);

  const blob = await canvasToBlob(output);
  return { blob, width, height };
};

export const buildEraseLayerObjectRequest = ({
  layer,
  maskBlob,
  maskWidth,
  maskHeight,
  canvasWidth,
  canvasHeight,
}) => ({
  layerId: layer?.id || null,
  layerUrl: layer?.url || null,
  isBackground: Boolean(layer?.isBackground),
  box: {
    x: Number(layer?.x) || 0,
    y: Number(layer?.y) || 0,
    width: Number(layer?.width) || 0,
    height: Number(layer?.height) || 0,
  },
  canvasWidth: Number(canvasWidth) || 0,
  canvasHeight: Number(canvasHeight) || 0,
  mask: {
    blob: maskBlob,
    width: Number(maskWidth) || 0,
    height: Number(maskHeight) || 0,
    mimeType: MASK_MIME_TYPE,
  },
});

export const createEraseMaskFile = (maskBlob, mimeType = MASK_MIME_TYPE) =>
  new File([maskBlob], `eraser-mask-${Date.now()}.png`, {
    type: mimeType || MASK_MIME_TYPE,
  });

export const canApplyEraseLayerObjectResult = ({
  layerId,
  layerUrl,
  layers = [],
}) => {
  const layer = layers.find((item) => item.id === layerId);
  if (!layer) return false;
  if (getLayerType(layer) !== LAYER_TYPE.IMAGE) return false;
  return String(layer.url || "") === String(layerUrl || "");
};
